import { css } from 'aphrodite';
import { MastheadPortalId } from '../../../models/AdminModels';
import { useFullscreenModal } from '../../../models/hooks/appStateHooks';
import { NavigationBreadcrumbsBar } from '../../../web/components/NavigationBreadcrumbsBar';
import { Portal } from '../../../web/components/Portal';
import { HangFireIcon } from '../../../web/components/svgs/icons/HangFireIcon';
import { ToolsCard } from '../../components/tools/ToolsCard';
import { styleSheet } from './styles';

export function DevTools() {
	const fullscreenModal = useFullscreenModal();

	const handleHangfireClick = () => {
		fullscreenModal.history.push('/devtools/hangfire');
	};

	return (
		<div>
			<Portal destination={MastheadPortalId}>
				<NavigationBreadcrumbsBar currentLocationName='DevTools' />
			</Portal>
			<div className={css(styleSheet.cards)}>
				<ToolsCard
					image={<HangFireIcon className={css(styleSheet.icon)} />}
					onClick={handleHangfireClick}
					title='Hangfire'
				>
					{['Generate job scheduler tokens']}
				</ToolsCard>
			</div>
		</div>
	);
}
